import { Checkbox } from "Components/Form/Checkbox";
import { TextManager } from "Components/TextContext";
import { useIsAdvisorSelector } from "Store/advisor/advisorSelectors";
import { isDefined } from "Utils/functions";
import { getError } from "Utils/productUtils";
import { useFormikContext } from "formik";
import React from "react";
import { AdvicePriceFormValues } from "../../AdviceCards/interfaces";
import { useAdviceResult } from "../../hooks/stateSelectors";
import { useResetAdviceDiffConsentIfChangesInForm } from "./hooks";
import { WhiteSurface } from "./styled";
import { checkShouldPurchaseAdviceFromAdvisor } from "./utils";

export const AdviceDiffConsent = (): React.ReactElement | null => {
  const { getText } = TextManager;
  const formProps = useFormikContext<AdvicePriceFormValues>();
  const isAdvisor = useIsAdvisorSelector();
  const adviceResult = useAdviceResult();
  useResetAdviceDiffConsentIfChangesInForm();

  if (!isDefined(adviceResult)) {
    return null;
  }

  const shouldPurchaseAdviceFromAdvisor = checkShouldPurchaseAdviceFromAdvisor(
    isAdvisor,
    adviceResult,
    formProps.values,
  );

  if (!shouldPurchaseAdviceFromAdvisor) {
    return null;
  }

  return (
    <WhiteSurface>
      <Checkbox
        id="adviceDiffConsent"
        name="adviceDiffConsent"
        label={getText("advicepage.advicediff.consent")}
        error={getError("adviceDiffConsent", formProps)}
      />
    </WhiteSurface>
  );
};
